<template>
  <div class="menu-wrapper">
    <template v-for="item in routes" v-if="!item.hidden&&item.children">

      <!-- 仅 1 个可见子项时收束为一行：必须用「可见子项」而非 children[0]（定义顺序第一项可能是已隐藏的 积分规则管理） -->
      <router-link v-if="canCollapseToSingleItem(item)" :to="resolvePath(firstVisibleChild(item).path, item.path)"
        :key="firstVisibleChild(item).name">
        <el-menu-item :index="resolvePath(firstVisibleChild(item).path, item.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <svg-icon v-if="firstVisibleChild(item).meta&&firstVisibleChild(item).meta.icon" :icon-class="firstVisibleChild(item).meta.icon"></svg-icon>
          <span v-if="firstVisibleChild(item).meta&&firstVisibleChild(item).meta.title" slot="title">{{firstVisibleChild(item).meta.title}}</span>
        </el-menu-item>
      </router-link>

      <el-submenu v-else :index="item.name||item.path" :key="item.name">
        <template slot="title">
          <svg-icon v-if="item.meta&&item.meta.icon" :icon-class="item.meta.icon"></svg-icon>
          <span v-if="item.meta&&item.meta.title" slot="title">{{item.meta.title}}</span>
        </template>

        <template v-for="child in item.children" v-if="!child.hidden">
          <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :routes="[child]" :base-path="resolvePath(child.path, item.path)" :key="child.path"></sidebar-item>
          <!--支持外链功能-->
          <a v-else-if="child.path.startsWith('http')" v-bind:href="child.path" target="_blank" :key="child.name">
            <el-menu-item :index="resolvePath(child.path, item.path)">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </a>
          <router-link v-else :to="resolvePath(child.path, item.path)" :key="child.name">
            <el-menu-item :index="resolvePath(child.path, item.path)">
              <svg-icon v-if="child.meta&&child.meta.icon" :icon-class="child.meta.icon"></svg-icon>
              <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>

    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  methods: {
    resolvePath(routePath, parentPath) {
      if (!routePath) return this.basePath || parentPath || '/'
      if (routePath.startsWith('http')) return routePath
      if (routePath.startsWith('/')) return routePath
      const base = (this.basePath || parentPath || '').replace(/\/$/, '')
      return base ? `${base}/${routePath}` : `/${routePath}`
    },
    getShowingChildren(children) {
      if (!children || !children.length) return []
      return children.filter((c) => !c.hidden)
    },
    hasOneShowingChildren(children) {
      return this.getShowingChildren(children).length === 1
    },
    /** 父级 meta.alwaysShow 为 true 时仍用展开子菜单，避免误用单条收束 */
    isAlwaysShowRoute(item) {
      return !!(item.meta && item.meta.alwaysShow)
    },
    firstVisibleChild(item) {
      const list = this.getShowingChildren(item.children)
      return list[0] || null
    },
    canCollapseToSingleItem(item) {
      if (this.isAlwaysShowRoute(item)) return false
      if (!this.hasOneShowingChildren(item.children)) return false
      const only = this.firstVisibleChild(item)
      if (!only) return false
      return !only.children
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue